import React, { useEffect, useState } from 'react';
import LocalFireDepartmentIcon from '@mui/icons-material/LocalFireDepartment';
import Typography500 from 'views/common/components/UI/Typography500';
import { useContent } from 'views/rebranded-module/common/context/useContent';
import StyledBox from 'views/rebranded-module/common/components/UI/AnnouncementBarV2/AnnouncementBarV2.styles';
 
const AnnouncementBarV2 = (props) => {
  const cmsData = useContent('NewMainWidgetComponent');
  const {
    vertical,
    slidingMessages = [
      cmsData.saveEvenMore,
      cmsData.futureBookings,
      cmsData.rideRoundTripOrOneWay,
    ],
  } = props;

  
  const [itemOrder, setItemOrder] = useState(0);
  const [unmount, setUnmount] = useState(false);

  useEffect(() => {
    setInterval(() => {
      setUnmount(true);
      setItemOrder((prevValue) => (prevValue + 1) % slidingMessages.length);
      setUnmount(false);
    }, 5000);
  }, []);

  return (
    <StyledBox
      className={`announcementBar ${vertical ? 'announcementBarVertical' : ''}`}
     >
      {!unmount && (
        <>
          <LocalFireDepartmentIcon className="announcementIcon" />
          <Typography500
            component="p"
            varient="h6"
            className="announcementItem">
            {slidingMessages[itemOrder]}
          </Typography500>
        </>
      )}
    </StyledBox>
  );
};
export { AnnouncementBarV2 };
